import { Name } from './Name';

export const FirstName = Name;
